import { Card, CardContent, Typography } from '@material-ui/core';
import { observer } from 'mobx-react';
import * as React from 'react';

import { LoadingPage } from '../../components/loading-page';
import { injectTSDI } from '../../core/common/tsdi';
import { I18n } from '../../core/i18n';
import { SharedContractDissolutionStore } from '../shared-contract-dissolution-store';

interface ActiveStudiosGateProps {
    emptyMessageKey: string;
    errorMessageKey: string;
    children: React.ReactNode;
}

export const ActiveStudiosGate = observer((props: ActiveStudiosGateProps) => {
    const { emptyMessageKey, errorMessageKey, children } = props;
    const { translate } = injectTSDI(I18n);
    const { getStudiosRequest } = injectTSDI(SharedContractDissolutionStore);

    const renderMessage = (messageKey: string) => (
        <Card variant="outlined">
            <CardContent>
                <Typography data-role="active-studios-gate-message">
                    {translate(messageKey)}
                </Typography>
            </CardContent>
        </Card>
    );

    return getStudiosRequest.match({
        loading: () => <LoadingPage />,
        default: () => <LoadingPage />,
        error: () => renderMessage(errorMessageKey),
        empty: () => renderMessage(emptyMessageKey),
        fetched: () => children
    });
});
